import _ from 'lodash'
import moment from 'moment'
import React, {Fragment, useContext } from 'react';

import Sidebar from "../../components/sidebar";
import {GlobalContext} from "../../handlers/GlobalContext";

const SidebarWrap = ({pid, countries, attachments, methods}) => {

    const [ state, dispatch] = useContext(GlobalContext);

    const revisionDates = _.filter(attachments, (att) => { return ['revision_date'].indexOf(att.attachmentType) > -1; });
    const revisionLinks = _.filter(attachments, (att) => { return ['revision_link'].indexOf(att.attachmentType) > -1; });
    const revisionRefs = _.filter(attachments, (att) => { return ['revision_ref'].indexOf(att.attachmentType) > -1; });

    const get_host = (url) => {
        return url.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1');
    }

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    const trackEvent = () => {
        dispatch({ type: 'TRACK_EVENT', payload: {event: 'print', label: 'product-id-' + pid} })
    }

    return (
        <Fragment>
            <Sidebar title={translate("product-sidebar-countriesTitle","Availability by countries")}>
                {countries.length > 0 ?
                    <div>
                        <div className="page-break"></div>
                        {
                            countries.map(country => (
                                <div key={'country_' + country.code}>
                                    <span> {/*{`${process.env.PUBLIC_URL + '/medicinal-products-by-drug/' + meta.drugId}`}*/}
                                        <i className="fa fa-globe"/> { translate("locale-country-" + country.code.toLowerCase(), country.longName)}
                                    </span>
                                </div>
                            ))
                        }

                    </div> :
                    <span> <i className="fa fa-exclamation-triangle"/> { translate("product-sidebar-noInfo","No information provided") } </span>
                }
            </Sidebar>

            <Sidebar title={translate("product-sidebar-dateRevisionTitle","Date of last revision")}>
                {revisionDates.length > 0 ?
                    <div>
                        <div className="page-break"></div>
                        {
                            revisionDates.map((revDate, idx) => (

                                <div key={'rev_date_' + idx}>
                                    <span><i className="fa fa-calendar"/> {moment(revDate.attachmentDate).format("DD.MM.yyyy")}</span>
                                    {!!revDate.description ? <p> {revDate.description} </p> : null}
                                    {(idx < (revisionDates.length - 1)) ? <hr/> : null}
                                </div>

                            ))
                        }

                    </div> :
                    <span> <i className="fa fa-exclamation-triangle"/> { translate("product-sidebar-noInfo","No information provided") } </span>
                }
            </Sidebar>

            {/*<Sidebar title={"Additional resources"}>*/}
                {/*<div>*/}
                    {/*<a href="javascript:void(0)"> /!*{`${process.env.PUBLIC_URL + '/medicinal-products-by-drug/' + meta.drugId}`}*!/*/}
                        {/*<i className="fa fa-file-pdf-o"/> Official record of approval*/}
                    {/*</a>*/}
                {/*</div>*/}
            {/*</Sidebar>*/}

            <Sidebar title={translate("product-sidebar-externalLinkTitle","External links")}>
                {revisionLinks.length > 0 ?
                    <div>
                        <div className="page-break"></div>
                        {
                            revisionLinks.map((revLink, idx) => (

                                <div key={'rev_link_' + idx}>
                                    <a href={revLink.url} target="_blank">
                                        <i className="fa fa-external-link"/> {get_host(revLink.url)} </a>
                                    {!!revLink.description ? <p> {revLink.description} </p> : null}
                                    {(idx < (revisionLinks.length - 1)) ? <hr/> : null}
                                </div>

                            ))
                        }

                    </div> :
                    <span> <i className="fa fa-exclamation-triangle"/> { translate("product-sidebar-noInfo","No information provided") } </span>
                }
            </Sidebar>

            <Sidebar title={translate("product-details-references","References")}>
                {revisionRefs.length > 0 ?
                    <div>
                        <div className="page-break"></div>
                        {
                            revisionRefs.map((revRef, idx) => (

                                <div key={'rev_ref_' + idx}>
                                    <p> {revRef.description} </p>
                                    {(idx < (revisionRefs.length - 1)) ? <hr/> : null}
                                </div>

                            ))
                        }

                    </div> :
                    <span> <i className="fa fa-exclamation-triangle"/> { translate("product-sidebar-noInfo","No information provided") } </span>
                }
            </Sidebar>

            <Sidebar>
                <button onClick={ (e) => {trackEvent(); methods.print(e)} }>
                    { translate("product-button-print","Print") }
                </button>
                {/*<button>*/}
                    {/*Download*/}
                {/*</button>*/}
            </Sidebar>
        </Fragment>
    );
};

export default SidebarWrap;